import { render, staticRenderFns } from "./DailyDetails.vue?vue&type=template&id=274ad673&scoped=true&"
import script from "./DailyDetails.vue?vue&type=script&lang=js&"
export * from "./DailyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ad673",
  null
  
)

export default component.exports